import { URL } from "../../api/Api";
import { JOBS } from "../Action";
import { catchError, DELETE, GET, getToken, POST, PUT } from "../axios/Axios";

export const GetJobList = async (payload, params) => {
  try {
    const response = await POST(`${URL}/intake/search/filter`, payload, params);

    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobSummary = (job_id, params = {}) => {
  return async (dispatch) => {
    try {
      const response = await GET(`${URL}/intake/job-summary/${job_id}`, params);
      dispatch({ type: JOBS.jobSummary, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const JobJobEdit = (job_id) => {
  return async (dispatch) => {
    try {
      const response = await GET(`${URL}/intake/jobdata/edit/${job_id}`, {});
      dispatch({ type: JOBS.jobJobEdit, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const JobJobStrategy = async (job_id) => {
  try {
    const response = await GET(`${URL}/intake/search/strategy/${job_id}`, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobJobSkillEdit = async (id, key, classification, payload) => {
  try {
    const getClassification = classification
      ? `&classification=${classification}`
      : "";
    const response = await POST(
      `${URL}/intake/skill/update?id=${id}&key=${key}${getClassification}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobJobShare = async (payload, type, id) => {
  try {
    const response = await POST(
      type === "Job" || type === "summary"
        ? `${URL}/intake/share/job?id=${id}`
        : `${URL}/matchengine/share/candidateprofile`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobJobSubmit = async (id, payload, params) => {
  try {
    const response = await PUT(
      `${URL}/intake/jobdata/edit/${id}`,
      payload,
      params ? params : {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobJobDelete = async (id) => {
  try {
    const response = await DELETE(
      `${URL}/matchengine/match/resume/jd/${id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobJobLock = async (payload) => {
  try {
    const response = await PUT(
      `${URL}/matchengine/matchresume/order`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobJobReScore = async (id, params, payload) => {
  try {
    const token = await getToken();
    const response = await fetch(
      `${URL}/intake/job/rescore/${id}?score=${params.score}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};

export const JobJobRescore = (jobValue) => {
  return {
    type: JOBS.jobJobRescore,
    data: jobValue,
  };
};

export const JobJobFormikData = (jobValue, values) => {
  return {
    type: JOBS.jobJobEditData,
    jobData: jobValue,
    formikData: values,
  };
};

export const JobCreateFormikData = (jobValue, values) => {
  return {
    type: JOBS.jobCreateEditData,
    jobData: jobValue,
    formikData: values,
  };
};

export const JobResumeDuplicate = async (params) => {
  try {
    const response = await POST(`${URL}/resume/save/`, {}, params);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

// Create-Job
export const JobIndustryList = async () => {
  try {
    const response = await GET(`${URL}/intake/industries/list/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobIndustrySubmit = async (payload) => {
  try {
    const response = await POST(`${URL}/intake/jobdata/title`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobIndustryScoreSubmit = async (param) => {
  try {
    const response = await POST(`${URL}/intake/jobdata/title/score`, {}, param);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobClassificationList = async (param) => {
  try {
    const response = await GET(`${URL}/intake/classification/list/`, param);
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobJDSubmit = async (payload) => {
  try {
    const token = await getToken();
    const response = await fetch(`${URL}/intake/jobdata/jd`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // const data = await response.json();
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw error;
  }
};

export const checkBackGroundProcess = async (job_id) => {
  try {
    const response = await POST(`${URL}/intake/jobdata/check/${job_id}`);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const CreateJobDelete = async (id) => {
  try {
    const response = await PUT(`${URL}/intake/remove/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const StatusChange = async (id, params) => {
  try {
    const response = await PUT(
      `${URL}/matchengine/change/status/${id}`,
      {},
      params
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const TableStatusChange = async (id, params) => {
  try {
    const response = await PUT(
      `${URL}/intake/jobdata/change-status/${id}`,
      {},
      params
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const TableStatusChangeList = async (params, payload) => {
  try {
    const response = await PUT(
      `${URL}/intake/jobdata/change-status-list`,
      payload,
      params
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const AttachementCreateCall = async (job_id, payload) => {
  try {
    const response = await POST(
      `${URL}/matchengine/match/attachment/${job_id}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const AttachementTableGetCall = async (job_id) => {
  try {
    const response = await GET(
      `${URL}/matchengine/match/attachment/${job_id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const AttachementDownload = async (job_id) => {
  try {
    const token = await getToken();
    const response = await fetch(
      `${URL}/matchengine/match/attachment/download/${job_id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};

export const AttachementDelete = async (id) => {
  try {
    const response = await DELETE(
      `${URL}/matchengine/match/attachment/${id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const AttachementViewGetCall = async (job_id) => {
  try {
    const response = await GET(
      `${URL}/matchengine/match/attachment/view/${job_id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobCandidateQueationEnable = async (payload) => {
  try {
    const response = await PUT(
      `${URL}/matchengine/match/prescreen/status`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobSkillDetails = async (payload) => {
  try {
    const response = await POST(`${URL}/intake/skill/details`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobEditCandidate = async (id, payload) => {
  try {
    const response = await PUT(
      `${URL}/matchengine/basic/info/${id}`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const GetJobDataDetail = async (job_id, params = {}) => {
  try {
    const response = await GET(`${URL}/intake/jobdata/${job_id}`, params);
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JudicaFilter = (data) => {
  return {
    type: JOBS.judicaFilter,
    data: data,
  };
};

export const CreateJobList = async (params) => {
  try {
    const response = await GET(`${URL}/intake/job-list`, params);
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const ScoringCandidate = async (job_id, params = {}) => {
  try {
    const response = await POST(
      `${URL}/intake/resume/suggestions/${job_id}`,
      params
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

//Analysis
export const JobCandidateAnalysis = async (id) => {
  try {
    const response = await GET(`${URL}/matchengine/match/analysis/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

//Candidate Sourcing
export const JobCandidateSourcing = (value) => {
  return {
    type: JOBS.jobCandidateSourcing,
    data: value,
  };
};

//workflow Management

export const WorkFlowManagement = (data) => {
  return {
    type: JOBS.workFlowManagement,
    data: data,
  };
};

export const DraftToActivate = async (id) => {
  try {
    const response = await PUT(`${URL}/automation/activate/job/${id}`, "", {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const ScoreToRequestInfo = async (payload) => {
  try {
    const response = await POST(
      `${URL}/automation/send_coversheet/`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const RequestInfoToLiveScreen = async (payload) => {
  try {
    const response = await PUT(`${URL}/automation/live_screen/`, payload, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const ShareToScore = async (id) => {
  try {
    const token = await getToken();
    const response = await fetch(`${URL}/jobs/${id}/source-and-match/`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};

//Candidate Resume

export const JobCandidateResume = (jobValue) => {
  return {
    type: JOBS.jobCandidateResume,
    data: jobValue,
  };
};

export const JobAttachementCreateCall = async (job_id, payload) => {
  try {
    const response = await POST(
      `${URL}/intake/job/attachments/${job_id}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobAttachementTableGetCall = async (job_id) => {
  try {
    const response = await GET(`${URL}/intake/job/attachments/${job_id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobAttachementDelete = async (id) => {
  try {
    const response = await DELETE(`${URL}/intake/job/attachments/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const JobAttachementDownload = async (job_id) => {
  try {
    const token = await getToken();
    const response = await fetch(
      `${URL}/intake/job/attachments/download/${job_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};

//Share Resume Upload Portal Link
export const ShareResumeUpload = async () => {
  try {
    const response = await GET(`${URL}/intake/resume/portal/generate-link`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const ResumePortalShare = async (payload) => {
  try {
    const response = await POST(
      `${URL}/intake/resume/portal/share`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

// Reference Check
export const GetReferenceCheck = async (matchId) => {
  try {
    const response = await GET(`${URL}/matchengine/reference/${matchId}`);
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const PutReferenceCheck = async (matchId, payload) => {
  try {
    const response = await PUT(
      `${URL}/matchengine/reference/${matchId}`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const PostReferenceCheck = async (matchId, payload) => {
  try {
    const response = await POST(
      `${URL}/matchengine/reference/${matchId}`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const GetReferenceStatus = async (matchId) => {
  try {
    const response = await GET(
      `${URL}/matchengine/reference/status/${matchId}`
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const SearchStringSkills = async (job_id, params) => {
  try {
    const response = await GET(
      `${URL}/intake/search/string/jd/${job_id}`,
      params
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const GenerateSearchStringPOST = async (id, payload) => {
  try {
    const response = await POST(
      `${URL}/intake/search/string/jd/${id}`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const SaveSearchStringSkill = async (id, payload) => {
  try {
    const response = await PUT(
      `${URL}/intake/search/string/jd/${id}`,
      payload,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};
